<!-- <a class="btn btn-primary" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="false" aria-controls="collapseExample">
    Link with href
  </a> -->
<nav id="filterCollapse" [ngClass]="{'collapse': !showFilter}"
  class="navbar navbar-light bg-light rounded btn-outline-secondary row mb-3 p-0"
  style="width:100%; margin-left:0%; margin-right:0%;">
  <!-- <app-tagfilter [label]="true" [listToFilter]="projectList" (filteredList)="setFilteredList($event)"  class="float-right" [tagtype]="'project'"></app-tagfilter> -->
  <div class="input-group p-13 col-4">
    <input type="text" style="margin-top:0px;" class="form-control h-40 mb-0"
      placeholder="{{ 'projectlist.filterplace' | trans }}" aria-label="Type to filter" aria-describedby="basic-addon2"
      name="textFilter" [ngModel]="filterTxt" (ngModelChange)="onFilterInput($event)">
  </div>
  <div class="col-6">
    <ng-container *ngIf="!showDisabled">
      <button (click)="toggleDisabled()" matTooltip="{{ 'projectlist.showdisabled' | trans }}"
        matTooltipPosition="above" matTooltipShowDelay="500" class="border-0 bg-transparent mt-1 float-right">
        <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle w-35 h-35">
          visibility
        </span>
      </button>
    </ng-container>
    <!--- SHOW WHEN DISABLED PROJECTS ARE SHOWN--->
    <ng-container *ngIf="showDisabled">
      <button (click)="toggleDisabled()" matTooltip="{{ 'projectlist.hidedisabled' | trans }}"
        matTooltipPosition="above" matTooltipShowDelay="500" class="border-0 bg-transparent mt-1 float-right">
        <span class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle w-35 h-35">
          visibility_off
        </span>
      </button>
    </ng-container>
    <app-tagfilter [label]="true" [listToFilter]="projectList" (filteredList)="setFilteredList($event)"
      class="float-right" [tagtype]="'project'"></app-tagfilter>
    <!-- <button class="btn rounded float-right pt-1 ml-2 pl-2 pr-2 pb-1" >
                        <p class="btn-text mb-0 ">ctag.title           
                          <span 
                          class="material-icons  align-middle f-15 lh-35 center p-0 align-middle">
                          close
                        </span>
                      </p>
                      </button>
                      <button class="btn rounded float-right pt-1 ml-2 pl-2 pr-2 pb-1" >
                        <p class="btn-text mb-0 ">ctag.title           
                          <span 
                          class="material-icons  align-middle f-15 lh-35 center p-0 align-middle">
                          close
                        </span>
                      </p>
                      </button>
                      <button class="btn rounded float-right pt-1 ml-2 pl-2 pr-2 pb-1" >
                        <p class="btn-text mb-0 ">ctag.title           
                          <span 
                          class="material-icons  align-middle f-15 lh-35 center p-0 align-middle">
                          close
                        </span>
                      </p>
                      </button> -->
    <!-- <span class="navbar-text">
                        Active filters
                      </span> -->
  </div>

</nav>
<div *ngIf="showNoProjectsMsg" class="container-fluid p-3">
  <div class="row">
    <div class="col-title">
      <h6 style="font-size: 15px;" class="page-header-title pl-3 mb-0">{{ 'projectlist.header' | trans }}</h6>
    </div>
  </div>
</div>

<div *ngIf="viewProjectList.length == 0 && !showNoProjectsMsg" class="container-fluid p-3">
  <div class="row">
    <div class="col-title">
      <h6 style="font-size: 15px;" class="page-header-title pl-3 mb-0">{{ 'projectlist.headerfilter' | trans }}</h6>
    </div>
  </div>
</div>
<!-- <div class="row ml-0 mr-0 mb-2 mt-2">
    <div class="col">
        <app-tagfilter [label]="true" [listToFilter]="projectList" (filteredList)="setFilteredList($event)"  class="float-right" [tagtype]="'project'"></app-tagfilter>
    </div>
</div> -->

<app-projectcard *ngFor="let project of viewProjectList; let i = index; trackBy: trackByProjectId" [project]="project"
  [filterTxt]="filterTxtDebounced" [showDisabled]="showDisabled" [customerportal]="customerportal" [pnewidth]="pnewidth"
  [showFilter]="showFilter" [orgedit]="orgedit" (clickWork)="clickWork($event)" (clickEdit)="clickEdit($event)"
  (clickAssign)="clickAssign($event)" (clickDelete)="clickDelete($event)" (clikcDisable)="clikcDisable($event)"
  (clickTemplate)="clickTemplate($event)" (clickAutomation)="clickAutomation($event)"
  [organizationId]="project.organizationId" [customerId]="project.customer" [timeregEnabled]="timeregEnabled"
  [timeSummary]="projectTimeSummary(project.projectId)" [showStartYear]="isOtherYear(project.start_date)"
  [showEndYear]="isOtherYear(project.end_date)">>
</app-projectcard>

<!-- Edit Modal -->
<div #orgProjectEditModal id="orgProjectEditModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <app-orgprojectedit class="modal-content" *ngIf="editProject" [project]="editProject"></app-orgprojectedit>
  </div>
</div>

<!-- Assign Modal -->
<div #assignProjectModal id="assignProjectModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'projectwizard.Assign' | trans }}</h5>
        <button type="button" class="close" (click)="closemodal(false)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-loadconfirm *ngIf="showSpinner" [text]="'assignProject.loader' | trans"
          [icon]="'pending'"></app-loadconfirm>

        <app-projectassign *ngIf="assignProject" [project]="assignProject" [reset]="reset"
          (doneLoading)="closeSpinner()" (closemodal)="closemodal($event)" [nomodal]="true"
          [standalone]="true"></app-projectassign>
      </div>
    </div>
  </div>
</div>

<!-- Template Modal -->
<div #projectTemplateModal id="projectTemplateModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <app-projecttemplatecreate *ngIf="templateProject" class="modal-content" [project]="templateProject"
      [list]="true"></app-projecttemplatecreate>
  </div>
</div>

<!-- Delete Modal -->
<div #deleteProjectModal id="deleteProjectModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <app-projectdelete *ngIf="projectToDelete" class="modal-content" [project]="projectToDelete"
      (projectDeleted)="deletedProject($event)">
    </app-projectdelete>
  </div>
</div>
<!-- Disable Modal -->
<div #disableProjectModal id="disableProjectModal" class="modal fade" role="dialog">
  <app-projectvisibilitytoggle class="modal-dialog modal-dialog-centered" *ngIf="setActiveStateProject"
    [project]="setActiveStateProject" (projectDisabled)="disabledProject($event)"></app-projectvisibilitytoggle>
</div>

<app-projectautomation [automationType]="'projectautomation'" [project]="automationProject"></app-projectautomation>

<app-alertbox *ngIf="showalerttoggle || showerrortoggle" [@inbgOutAnimation] [alerticon]="'check_circle'"
  [alerttype]="'success'" [alerttext]="'projectdelete.deletemsg' | trans "></app-alertbox>